import React from 'react';
import { StyleSheet, ScrollView } from 'react-native';
import theme from '../../constants/theme.style.js';
import CustomText from '../customText/CustomText';

const styles = StyleSheet.create({
  textContainer: {
    marginTop: 15,
    marginLeft: theme.CONTAINER_MARGIN,
    marginRight: theme.CONTAINER_MARGIN,
    fontSize: theme.FONT_SIZE_HEADLINE,
  },
});

export const MessageDetailText = ({ text }) => (
  <ScrollView>
    <CustomText style={styles.textContainer}>{text}</CustomText>
  </ScrollView>
);

export default MessageDetailText;
